import React from 'react';
import { Box, Text } from 'core/components';
import DeviceConfigView from 'app/components/device/DeviceConfigView';
import styled from 'styled-components';
import { FiTerminal } from 'react-icons/fi';
import ToolResultCard from '../components/ToolResultCard';

const CommandSection = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin: 0 8px 4px 8px;
  background: #263238;
  border-radius: 4px;
  font-family: ${({ theme }) => theme.fonts.monospace};

  .command-icon {
    color: ${({ theme }) => theme.colors.muted};
    flex-shrink: 0;
  }

  .command-text {
    color: #cad3f5;
    font-size: 14px;
    font-weight: 500;
    word-break: break-all;
  }
`;

const CodeMirrorContainer = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  background: #263238;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 8px 8px 8px;

  > div {
    flex: 1;
    display: flex;
  }

  .cm-editor {
    flex: 1;
    height: 100%;
    width: 100%;
    background-color: transparent;
  }

  .cm-scroller {
    flex: 1;
    overflow: auto;
  }

  .cm-gutters {
    background-color: #263238;
    color: #537f7e;
    border: none;
  }
`;

/**
 * DeviceCommandToolResult
 * Shows the result of a device command in a code block.
 * Only displays the returned result, nothing else.
 */
const DeviceCommandToolResult = ({ tool, onCloseToolResult, isInlineMode = false }) => {
  const result = tool?.raw_result ?? {};
  return (
    <ToolResultCard
      tool={tool}
      onCloseToolResult={onCloseToolResult}
      className="tool-result-device-command"
      title={tool.title || 'Device Command Result'}
      isInlineMode={isInlineMode}
      minHeight={450}
    >
      {result.command && (
        <CommandSection>
          <FiTerminal className="command-icon" size={16} />
          <Text className="command-text">{result.command}</Text>
        </CommandSection>
      )}
      <CodeMirrorContainer>
        <DeviceConfigView configText={result.output || ''} syntax="plain" />
      </CodeMirrorContainer>
    </ToolResultCard>
  );
};

export default DeviceCommandToolResult;
